import { render, staticRenderFns } from "./NoPassCreate.vue?vue&type=template&id=2b124d62&scoped=true"
import script from "./NoPassCreate.vue?vue&type=script&lang=js"
export * from "./NoPassCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b124d62",
  null
  
)

export default component.exports